export default {
  "client": "Bill & Melinda Gates Foundation",
  "bannerImage": require("../../../img/mocks/pdr_hero.png"),
  "productImageSmall": require("../../../img/mocks/pdr-small.png"),
  "product": "PDredesign",
  "services": [
    "Product Design",
    "Project Management",
    "Software Development"
  ],
  "problemsSolved": [],
  "timeLine": [
    {
      "date": "November 2013",
      "summary": "Project kick off",
      "icon": "hourglass-start",
      "iconColor": "gray"
    },
    {
      "date": "January 2014",
      "summary": "Remote user feedback",
      "icon": "comments",
      "iconColor": "blue"
    },
    {
      "date": "March 2014",
      "summary": "Deliver working prototype to waiting users",
      "icon": "graduation-cap",
      "iconColor": "green"
    },
    {
      "date": "October 2014",
      "summary": "Add partner functionality based on real world use",
      "icon": "group",
      "iconColor": "dark"
    },
    {
      "date": "2015",
      "summary": "Open source the codebase of PDredesign",
      "icon": "heart-o",
      "iconColor": "red"
    },
    {
      "date": "April 2016",
      "summary": "Add new tools to the toolkit",
      "icon": "wrench",
      "iconColor": "green"
    }
  ]
}
